/**
 * SyncProgress component — shown on the onboarding page after Amazon binding succeeds.
 *
 * Lets users enter while data is being prepared.
 */
import { IconCloudDownload } from "@tabler/icons-react";
import { useNavigate } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useInitialSyncStatus } from "@/hooks/use-initial-sync-status";
import { useShopSyncStatus } from "@/hooks/use-shop-sync-status";

export function SyncProgress() {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();
  const navigatedRef = useRef(false);
  const { data: syncStatus } = useShopSyncStatus();
  const { isComplete } = useInitialSyncStatus(syncStatus);

  useEffect(() => {
    if (isComplete && !navigatedRef.current) {
      navigatedRef.current = true;
      toast.success(t("syncing.dataReady"));
      const timer = setTimeout(() => navigate({ to: "/" }), 3000);
      return () => clearTimeout(timer);
    }
  }, [isComplete, navigate, t]);

  return (
    <div className="flex flex-col items-center gap-6 text-center">
      <div className="flex size-14 items-center justify-center rounded-full bg-success/10">
        <IconCloudDownload className="size-7 text-muted-foreground" />
      </div>

      {/* Enter Dashboard — doesn't wait for sync */}
      <Button onClick={() => navigate({ to: "/" })}>{t("syncing.enterDashboard")}</Button>
    </div>
  );
}
